import { render, staticRenderFns } from "./registerOnline.vue?vue&type=template&id=78d54741&scoped=true&"
import script from "./registerOnline.vue?vue&type=script&lang=js&"
export * from "./registerOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d54741",
  null
  
)

export default component.exports